import {Modal} from 'antd';
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, Dispatch} from 'redux';
import icon from "../../../assets/images/modal-icon-error.svg";
import {ErrorDto} from '../../../core/models/dtos/error.dto';
import {setApiError} from '../../../core/services/appService/setApiError/actions';
import {SetApiErrorState} from '../../../core/services/appService/setApiError/types';
import FirebaseService from "../../../core/services/firebaseService/firebase.service";
import {Constants} from "../../../core/utilities/constants";
import {IStore} from '../../../core/utilities/reducers';
import {UI} from '../../../core/utilities/ui';
import FirebaseKey from "../../FirebaseKey/FirebaseKey";
import './ApiErrorModal.scss';

interface IProps {
  apiErrorState: SetApiErrorState;
  setApiError: (error?: ErrorDto) => void;
}

const ApiErrorModal = (props: IProps) => {
  const isVisible = (): boolean => {
    return !!props.apiErrorState.error;
  };

  return (
    <Modal
      className="api-error-modal"
      maskStyle={UI.modalMaskStyle()}
      visible={isVisible()}
      closable={false}
      footer={false}
      centered
      destroyOnClose
      onCancel={() => props.setApiError()}
    >
      {props.apiErrorState.error &&
        <div className="content">
          <img className="icon" src={icon} alt="icon"/>
          <FirebaseKey className="title" firebaseKey={FirebaseService.error_title}/>
          <FirebaseKey className="text" firebaseKey={FirebaseService.error_description}/>
          <a
            className="app-button"
            href={Constants.kgbAppLink}
            rel="noreferrer nooppener"
          >
            <FirebaseKey firebaseKey={FirebaseService.error_button}/>
          </a>
        </div>
      }
    </Modal>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      setApiError,
    },
    dispatch,
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    apiErrorState: store.setApiError,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ApiErrorModal);
